// extracted by mini-css-extract-plugin
export default {"drinkActions":"DrinkActions_drinkActions__6pQ-p","addButton":"DrinkActions_addButton__r64Tt"};